import hardwareCycle from "./silicon-optics-substations.json";
import bottleneck from "./the-bottleneck-moved.json";

export const editorialArticles = [hardwareCycle, bottleneck];
export function getEditorialArticle(slug) {
  return editorialArticles.find((article) => article.slug === slug) || null;
}
export function mergeEditorialArticles(articles = []) {
  const curatedSlugs = new Set(editorialArticles.map((article) => article.slug));
  return [...editorialArticles, ...articles.filter((article) => !curatedSlugs.has(article.slug))]
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
}
